export enum NoteRefType {
  Customer = "CUSTOMER",
  Opportunity = "OPPORTUNITY",
  Order = "ORDER",
}

export enum NoteType {
  Manual = "MANUAL",
  System = "SYSTEM",
}

export interface NoteStaff {
  id: number;
  name: string;
  avatar: string;
}

export interface Note {
  id: number;
  content: string;
  type: NoteType;
  refType: NoteRefType;
  refId: number;
  linkType: "OPPORTUNITY" | "ORDER" | null;
  linkId: number;
  createdAt: number;
  staff: NoteStaff | null;
}
